export const isEnterOrSpace = (keyBoardEvent) => {
  return ['Enter', ' '].includes(keyBoardEvent.key);
};
